<script setup lang="ts">
import { useAuthUser } from '@/helpers/globals';
import { RouterLink, RouterView } from 'vue-router';

const authUser = useAuthUser();
</script>

<template>
    <main class="ktg-main-container">
        <h1 class="ktg-title-01 mb-2rem" v-html="$t('useracccount_welcome_name', {vorname: authUser?.vorname, nachname: authUser?.nachname})"></h1>
        <p class="ktg-body pb-3rem" v-html="$t('useracccount_main_info_txt')"></p>
        <nav class="mb-2rem">
            <ktg-tabs>
                <RouterLink :to="{ name: 'useraccount-settings-profile' }" custom v-slot="{ isActive, navigate }">
                    <ktg-tab :active="isActive || null" @activate="navigate">{{ $t('settings') }}</ktg-tab>
                </RouterLink>
                <RouterLink :to="{ name: 'useraccount-notifications' }" custom v-slot="{ isActive, navigate }">
                    <ktg-tab :active="isActive || null" @activate="navigate">{{ $t('notifications') }}</ktg-tab>
                </RouterLink>
            </ktg-tabs>
        </nav>

        <RouterView></RouterView>
    </main>
</template>
